import { DomainError } from '../shared/DomainError';
import { TaskStatus } from './enums';
import type { DailyStep } from './models';

export type DailyStepTransition = 'start' | 'complete' | 'reset' | 'skip';

function withoutOutcome(step: DailyStep) {
  const base = { ...step };
  delete base.startedAt;
  delete base.completedAt;
  delete base.postponedToDate;
  delete base.postponedToStepId;
  return base;
}

export function transitionDailyStep(
  step: DailyStep,
  transition: DailyStepTransition,
  timestamp: string,
): DailyStep {
  switch (transition) {
    case 'start':
      if (step.status !== TaskStatus.pending && step.status !== TaskStatus.skipped) {
        throw new DomainError('invalid_step_transition', 'Cette mission ne peut pas être démarrée.');
      }
      return {
        ...withoutOutcome(step),
        status: TaskStatus.inProgress,
        startedAt: timestamp,
        updatedAt: timestamp,
      };
    case 'complete':
      if (step.status !== TaskStatus.pending && step.status !== TaskStatus.inProgress) {
        throw new DomainError('invalid_step_transition', 'Cette mission ne peut pas être terminée.');
      }
      return {
        ...withoutOutcome(step),
        status: TaskStatus.completed,
        ...(step.startedAt ? { startedAt: step.startedAt } : {}),
        completedAt: timestamp,
        updatedAt: timestamp,
      };
    case 'reset':
      if (
        step.status !== TaskStatus.completed &&
        step.status !== TaskStatus.inProgress &&
        step.status !== TaskStatus.skipped
      ) {
        throw new DomainError('invalid_step_transition', 'Cette mission ne peut pas être remise à faire.');
      }
      return {
        ...withoutOutcome(step),
        status: TaskStatus.pending,
        updatedAt: timestamp,
      };
    case 'skip':
      if (step.status === TaskStatus.postponed) {
        throw new DomainError('invalid_step_transition', 'Une mission reportée ne peut pas être ignorée.');
      }
      return {
        ...withoutOutcome(step),
        status: TaskStatus.skipped,
        updatedAt: timestamp,
      };
  }
}
